module.exports = __webpack_public_path__ + "img/comment.174b7457.svg";